<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, index) in swiperList" :key="index">
        <div class="banner">
          <img :src="formatURL(item.imageUrl)" />
        </div>
      </swiper-slide>
    </swiper>
    <div class="mainBody">
      <div class="conTit">
        <span>你的位置：</span
        ><em @click="retunNew"
          >新闻动态 > {{ column == 1 ? '党建动态' : '企业动态' }} ></em
        ><i>新闻详情页</i>
        <div class="goUp" @click="Rtrouter">返回>></div>
      </div>
      <div class="newsDetail">
        <div class="title">{{ content.infoManage.infoName }}</div>
        <div class="fbtime">
          {{ '发布于:' + content.infoManage.createTime }}
        </div>
        <div
          class=" ql-snow ql-editor"
          v-html="content.infoManage.infoContent"
        ></div>
        <div
          class="file"
          @click="download(content.infoManage.fileUrl)"
          v-if="content.infoManage.fileUrl"
        >
          <span>附件：</span><i>{{ content.infoManage.fileUrlNames }}</i>
        </div>
      </div>
      <div class="newdNav clear">
        <div
          class="newdNav_L fl"
          v-if="content.last"
          @click="goRouter(content.last.infoId)"
        >
          <span
            >上一篇：
            <i>{{ content.last ? content.last.infoName : '' }}</i></span
          >
        </div>
        <div
          class="newdNav_R fl"
          v-if="content.next"
          @click="goRouter(content.next.infoId)"
        >
          <span
            >下一篇：<i>{{
              content.next ? content.next.infoName : ''
            }}</i></span
          >
        </div>
      </div>
      <div class="returnB" @click="Rtrouter">返回</div>
    </div>
  </div>
</template>
<script>
import { formatURL } from '@/util/index.js'
import { infoManageDetail, dict, imageAdvertisingList } from '@/api/index'
export default {
  data() {
    return {
      infoId: '',
      infoContent: '',
      title: '',
      url: this.$httpUrl,
      swiperOption: {},
      content: '', //总数据
      swiperList: [],
    }
  },
  mounted() {
    console.log('新闻id', this.$route.query.id)
    let id = this.$route.query.id
    let column = this.$route.query.column
    this.id = id
    this.column = column
    this.getInfoDetail(id, column)
    this.getImg()
  },
  methods: {
    formatURL,
    retunNew() {
      let column = this.column
      this.$router.push({ path: '/news', query: { id: column } })
    },
    // 下载表单
    download(url) {
      window.location = this.$httpUrl + url
    },
    returnUp() {
      this.$router.go(-1) //返回上一层
    },
    //获取字典类型
    async getImg() {
      // let pageType = await dict("pageset_type")
      // console.log("字典", pageType)
      let dictV = 6
      imageAdvertisingList({ advertisingPosition: dictV }).then((res) => {
        console.log('广告', res.rows)
        this.swiperList = res.rows
      })
    },

    cleanRichText(html) {
      return html.replace(/<img[^>]*src="([^"]*)"[^>]*>/g, (match, src) => {
        // 1. 去掉协议头 (http:// 或 https://)
        let cleanSrc = src.replace(/^https?:/, '')
        // 2. 去掉端口号 (:8080 等)
        cleanSrc = cleanSrc.replace(/:\d+(?=\/|$)/, '')
        // 3. 替换回原标签
        return match.replace(src, cleanSrc)
      })
    },
    getInfoDetail(id, column) {
      infoManageDetail(id + '/' + column).then((res) => {
        // console.log(res.data.infoContent)
        // this.infoContent = res.rows[0].infoContent
        let resInfo = res.rows[0]
        try {
          resInfo.infoManage.infoContent = resInfo.infoManage.infoContent.replace(
            /<img/g,
            "<img style='max-width:100%;height:auto;'",
          )

          resInfo.infoManage.infoContent = this.cleanRichText(
            resInfo.infoManage.infoContent,
          )
          console.log(resInfo)
          this.content = resInfo
        } catch (error) {
          this.content = resInfo
          console.log(error)
        }

        // console.log('新闻详情页',this.content)
      })
    },
    Rtrouter() {
      this.$router.go(-1)
    },
    goRouter(id) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.getInfoDetail(id, this.column)
    },
  },
}
</script>
<style lang="scss" scoped>
.ql-editor {
  white-space: normal !important;
}

.ql-container {
  white-space: pre-wrap !important;
}

.ql-editor {
  line-height: 30px;

  p {
    text-indent: 35px;
  }
}

.banner {
  width: 100%;

  img {
    width: 100%;
  }
}

.file {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #eeeeee;

  span {
    width: 100px;
    text-align: center;
    height: 100%;
    background: #f5f5f5;
    /* color:#fff;  */
    display: inline-block;
    margin-right: 10px;
  }

  i {
    font-style: normal;
    font-size: 16px;
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
  }
}

.newsDetail {
  width: 100%;
  height: auto;
  text-align: left;
  /* margin-top: 60px; */
  margin-bottom: 50px;
  padding: 40px 80px;
  box-sizing: border-box;
  background-color: #fdfdfd;
  border: solid 2px #f1f1f1;

  .title {
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 2px;
    color: #333333;
    margin-bottom: 20px;
  }

  .detail {
    font-size: 18px;
    /* font-weight: 300; */
    line-height: 48px;
    letter-spacing: 3px;
    color: #333333;
  }
}

.newdNav {
  font-size: 16px;
  font-weight: 400;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #999999;

  i {
    max-width: 518px;
    display: inline-block;
    cursor: pointer;
    font-style: normal;
    color: #0a308f;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    vertical-align: middle;
    top: -2px;
  }
}

.newdNav_L {
  width: 50%;
  overflow: hidden;
  text-align: left;
}

.newdNav_R {
  width: 50%;
  overflow: hidden;
  padding-left: 84px;
  box-sizing: border-box;
  /* text-overflow:ellipsis;
        white-space: nowrap; */
  text-align: left;

  i {
    max-width: 440px;
  }
}

.returnB {
  width: 235px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  /* font-weight: 300; */
  color: #ffffff;
  cursor: pointer;
  background-color: #f39800;
  border-radius: 10px;
  margin: 82px auto 0 auto;
}

.fbtime {
  font-size: 16px;
  color: #666666;
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 50px;
}

.conTit {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #eeeeee;
  text-align: left;
  padding: 0 22px;
  margin-top: 60px;
  box-sizing: border-box;
  font-size: 16px;
  /* font-weight: 300; */
  color: #666666;
  position: relative;

  span {
    font-size: 18px;
    /* font-weight: 300; */
    color: #0a308f;
    font-weight: 600;
  }

  em {
    font-style: normal;
    cursor: pointer;
  }
  i {
    font-style: normal;
  }
}

.goUp {
  color: #0a308f;
  position: absolute;
  right: 20px;
  top: 0px;
  cursor: pointer;
  font-weight: 400;
}
</style>
